import React, { useEffect, useState } from 'react';
import '../../Advertiser/AdvertiserOnboarding/AdvertiserOnboarding.css';

const STEP_COPY = {
    compose_input: {
        title: 'Type what you want on screen',
        body: 'Describe a promotion, menu update, or announcement — INVERT designs it instantly for every display.',
    },
    nav_screens: {
        title: 'Manage your screens',
        body: 'See connected displays, turn screens on or off, and check status from the Screens tab.',
    },
    nav_library: {
        title: 'Content library',
        body: 'Every design you create is saved here so you can reuse or schedule it later.',
    },
};

export default function ScreenHostOnboardingSpotlight({
    activeStepId,
    targetSelector,
    onNext,
    onSkip,
    showSkip,
}) {
    const [rect, setRect] = useState(null);

    useEffect(() => {
        if (!activeStepId || !targetSelector) {
            setRect(null);
            return undefined;
        }

        const update = () => {
            const el = document.querySelector(`[data-onboarding-id="${targetSelector}"]`);
            if (!el) {
                setRect(null);
                return;
            }
            const r = el.getBoundingClientRect();
            setRect({
                top: r.top - 8,
                left: r.left - 8,
                width: r.width + 16,
                height: r.height + 16,
            });
        };

        update();
        window.addEventListener('resize', update);
        window.addEventListener('scroll', update, true);
        const t = setInterval(update, 400);
        return () => {
            window.removeEventListener('resize', update);
            window.removeEventListener('scroll', update, true);
            clearInterval(t);
        };
    }, [activeStepId, targetSelector]);

    if (!activeStepId || activeStepId === 'welcome' || activeStepId === 'install_app' || activeStepId === 'done') {
        return null;
    }

    const copy = STEP_COPY[activeStepId] || { title: 'Tip', body: '' };
    const tooltipTop = rect ? Math.min(rect.top + rect.height + 12, window.innerHeight - 200) : 80;
    const tooltipLeft = rect ? Math.min(rect.left, window.innerWidth - 340) : 24;

    return (
        <>
            {!rect && <div className="advertiser-onboarding-backdrop" />}
            {rect && (
                <div
                    className="advertiser-onboarding-spotlight-hole"
                    style={{
                        top: rect.top,
                        left: rect.left,
                        width: rect.width,
                        height: rect.height,
                    }}
                />
            )}
            {!rect && <div className="advertiser-onboarding-backdrop" />}
            <div
                className="advertiser-onboarding-tooltip"
                style={{ top: tooltipTop, left: Math.max(16, tooltipLeft) }}
            >
                <h3>{copy.title}</h3>
                <p>{copy.body}</p>
                <div className="advertiser-onboarding-tooltip-actions">
                    <button type="button" className="advertiser-onboarding-btn advertiser-onboarding-btn-primary" onClick={onNext}>
                        Next
                    </button>
                    {showSkip && (
                        <button type="button" className="advertiser-onboarding-btn advertiser-onboarding-btn-ghost" onClick={onSkip}>
                            Skip tour
                        </button>
                    )}
                </div>
            </div>
        </>
    );
}
